import React, { useEffect, useState } from "react";
import { Layout, Menu, Card, Typography } from "antd";
import {
  UserOutlined,
  MenuFoldOutlined,
  LaptopOutlined,
  LogoutOutlined,
  HomeOutlined,
  UserAddOutlined,
  RocketOutlined
} from "@ant-design/icons";
import { NavLink } from "react-router-dom";
// import Avatar from 'react-avatar';
import "./index.css";
import Logout from "../Components/Logout";
import FieldInfoModal from "../Fmu/FieldInfoModal";
import { Avatar, Space } from "antd";
import { VersionReleaseNote } from "../Fmu/VersionReleaseNote";
import { handleAuthCallback, redirectToLogin, logout } from "../auth/AuthService";


const { SubMenu } = Menu;
const { Header, Content, Sider, Footer } = Layout;
const { Title, Text } = Typography;

const Sidebar = (props) => {
  const [collapsed, setCollapsed] = useState(true);
  const [tabs, setTab] = useState('');
  const [isModalVisible, setIsModalVisible] = useState('');
  // const getUserInfo = localStorage.getItem("userinfo");
  // const userDetail = JSON.parse(getUserInfo);
  // const userRole = userDetail?.User_Role;
  const storedUser = JSON.parse(localStorage.getItem("ecotrip_user"))?.idTokenClaims;
   const storderDetails = storedUser ?  storedUser : "";
  const versionNoteAccess =["deepak.n@contractor.tranetechnologies.com","Rohit.Dhumane@tranetechnologies.com","Midhun.Damodaram@tranetechnologies.com","Mitch.Howe@tranetechnologies.com","Rajib.Rony@tranetechnologies.com","Bill.Mohs@tranetechnologies.com"]; 
  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.reload();
    // <Logout />;
  };
  useEffect(()=>{
    const currentTab =  window.location.pathname.replace('/','').toLowerCase();
    setTab(currentTab);
  },[])
  const handlechange = () => {
    setCollapsed(!collapsed);
  };
  const showInfoModal = () => {
    console.log("clicked model")
    setIsModalVisible(true);
  };

  const handleCloseInfoModal = () => {
    setIsModalVisible(false);
  };  

  return (
    <>
      <Layout className="sidebar">
        <Sider
          width={250}
          theme="light"
          trigger={null}
          collapsible
          collapsed={collapsed}
          onCollapse={handlechange}
          defaultCollapsed={true}
        >
          <Header
            className="site-layout-background"
            style={{ padding: 0, color: "blue", background:"#a079e4", }}
          >
            {React.createElement(MenuFoldOutlined, {
              className: "trigger",
              onClick: handlechange,
            })}
          </Header>
          {!collapsed && (
            <div className="user-information">
              {/* <Avatar
        NAME = {"Akshat Saxena"}
          round
          color='#bfbfbf'
        /> */}
              <Space wrap size={16}>
                <Avatar shape="square" size={64} icon={<UserOutlined />} />
              </Space>
              <>
                <Title level={3} style={{ color: "#000000", paddingTop: 10 }}>
                  {/* {"AKSHAT SAXENA"} */}
                  {`${storderDetails?.FirstName ||  localStorage.getItem("ecotrip_user") ? JSON.parse( localStorage.getItem("ecotrip_user"))?.idTokenClaims?.FirstName : ''} ${storderDetails?.LastName ||  localStorage.getItem("ecotrip_user") ? JSON.parse( localStorage.getItem("ecotrip_user"))?.idTokenClaims?.LastName:""}`}
                </Title>
                {/* <Text style={{ color: "black" }}> */}
                  {/* {"Software Engineer"} */}
                  {/* {userDetail?.Designation}
                </Text> */}
              </>
              {/* )} */}
            </div>
          )}
          <Menu
            theme="light"
            mode="inline"
            defaultSelectedKeys={["/"]}
            selectedKeys={["Chennai"]}
          >
            {/* <Menu.Item
              key="/Dashboard"
              icon={<HomeOutlined />}
              className="home"
            >
              <NavLink to={"/Dashboard"}>Home</NavLink>
            </Menu.Item>
            <SubMenu key="sub1" icon={<UserOutlined />} title="Models"> */}
              {/* <Menu.Item key='/TraneDRM' icon={<LaptopOutlined />} className='TraneDRM'>
            <NavLink to={'/TraneDRM'}>Demand Management</NavLink>
          </Menu.Item> */}
              {/* <Menu.Item
                key="/RangeForcasting"
                icon={<LaptopOutlined />}
                className="RangeForcasting"
              >
                <NavLink to={"/RangeForcasting"}>Range Forcasting</NavLink>
              </Menu.Item> */}
              {/* <Menu.Item
                key="/ECoTRIP"
                icon={<LaptopOutlined />}
                className="FCMT"
              >
                <NavLink to={"/ECoTRIP"}>ECoTRIP</NavLink>
              </Menu.Item>
            </SubMenu> */}
            {/* {userRole === "ADMIN" && (
              <Menu.Item
                key="/Admin"
                icon={<UserAddOutlined />}
                className="AdminList"
              >
                <NavLink to={"/Admin"}>Admins</NavLink>
              </Menu.Item>
            )} */}
            { versionNoteAccess.includes(storderDetails?.EmailID ||JSON.parse( localStorage.getItem("ecotrip_user"))?.idTokenClaims?.EmailID) && (
            <Menu.Item
              key=""
              icon={<RocketOutlined />}
              className="logout-menu"
              // style={{paddingRight:'44px'}}
              onClick={showInfoModal}
            >
              <div onClick={showInfoModal}>
                Version Release Note ({process.env.REACT_APP_VERSION})
              </div>
            </Menu.Item>
            )}
            <Menu.Item
              key="/"
              icon={<LogoutOutlined />}
              className="logout-menu"
            >
              <NavLink to={"/"} onClick={logout}>
                Logout
              </NavLink>
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout className={tabs}>
          <Content>
            <Card
              className="rounded shadow-sm"
              //  style={{ margin: "12px 12px 0px 12px", minHeight: "650px" }}
               style={{ height:"calc(100vh - 35px)", }}
            >
              {props.children}
            </Card>
          </Content>
        </Layout>
      </Layout>
      <FieldInfoModal
        visible={isModalVisible}
        onClose={handleCloseInfoModal}
        fieldInfo={VersionReleaseNote}
        releaseNote={isModalVisible?true : false}
      />
      <Footer
        style={{
          textAlign: 'center',
          display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            // position: "relative",
            padding: "10px 10px"
        }}
      >
      <h3 style={{
        position: "absolute",
            left: "50%",
            transform: "translateX(-50%)"
      }}>
        © {new Date().getFullYear()} Copyright: Trane Technologies
      </h3>
        <div className="version" style={{ marginLeft: "auto"}}>{process.env.REACT_APP_VERSION}</div>
      </Footer>
    </>
  );
};

export default Sidebar;
